/**
 * 스캔 오인식 신고 API — SC-027 · FN-074 (be `POST /api/v1/user/scan/reports`).
 *
 * ⚠ **인증 필요**다. 라벨 수집(/scan/labels)은 비회원도 올리지만 신고는 아니다 —
 *   화면도 누른 순간 로그인으로 보낸다(components/report/useMisreadReport).
 * ⚠ 유형(kind)은 그대로 문자열로 보낸다. BE 가 이것을 처리 큐 코드로 옮기므로,
 *   여기서 코드로 바꿔 보내면 같은 표가 두 곳에 생긴다.
 */
import { apiPost } from "./client";

export interface ScanReportRequest {
  cardUid: string;
  /** 카탈로그에 적재된 카드면 함께 보낸다. 인덱스⊃카탈로그라 없을 수 있다 */
  cardSerialNo?: number;
  kind: string;
  correctCardUid?: string;
  correctCardSerialNo?: number;
  /**
   * 스캔 사진이 함께 왔는지. **FE 는 지금 보내지 않는다** — 붙일 파일이 없어서다
   * (misreadReport.ts 참조). 빠진 값을 BE 가 N 으로 적으므로 선택 필드로 둔다.
   * 서버 계약이라 지우지는 않는다. 첨부가 생기면 여기가 먼저 살아난다.
   */
  attachPhoto?: boolean;
  /** 스캔한 시각 (ISO) */
  scannedAt?: string;
}

export interface ScanReportResponse {
  scanReportSerialNo: number;
}

export function createScanReport(req: ScanReportRequest): Promise<ScanReportResponse> {
  return apiPost<ScanReportResponse>("/scan/reports", req);
}
